import {Component} from 'substance'

/**
 * @typedef UITooltip.props
 * @property {string} title - Tooltip title
 * @property {string} text - Tooltip text
 * @property {boolean} show - If the tooltip should be visible, defaults to false
 * @property {boolean} fixed - Set to true if the tooltip should be possisioned fixed instead of absolute, defaults to false
 */

/**
 * @typedef UITooltip.state
 * @property {boolean} show - If the tooltip is visible
 */

/**
 * A tooltip component
 *
 * @name UITooltip
 * @class
 *
 * @example
 * import {UITooltip} from 'writer'
 *
 * render($$) {
 *     const el = $$('div')
 *
 *     return el.append(
 *         $$(UITooltip, {
 *             title: 'My neat tooltip',
 *             text: 'Hello World',
 *             fixed: false,
 *             show: true
 *         })
 *     )
 * }
 *
 * @param {UITooltip.props} props
 * @property {UITooltip.props} props
 * @property {UITooltip.state} state
 */
class TooltipComponent extends Component {

    constructor(...args) {
        super(...args)

        this.hide = this.hide.bind(this)
    }

    dispose() {
        document.removeEventListener('scroll', this.hide, true)
    }

    /**
     * Default state of tooltip is invisible
     *
     * @returns {object}
     * @private
     */
    getInitialState() {
        return {show: false}
    }

    willReceiveProps(newProps) {
        if (newProps.hasOwnProperty('show')) {
            this.setState({
                show: newProps.show
            })
        }
    }

    hide() {
        document.removeEventListener('scroll', this.hide, true)
        this.extendState({show: false})
    }

    render($$) {
        const el = $$('span')
            .ref('tooltip')
            .addClass(`tooltip ${this.props.fixed ? 'fixed' : ''}`)

        // Hack: If somehow the tooltip is stuck in display mode
        // we solve it by removing when mouseover.
        el.on('mouseover', () => {
            this.setState({
                show: false
            })
        })

        el.append($$('p').append(this.props.title))
        el.append(this.props.text)

        const parent = this.props.parent ? this.props.parent.el : this.parent.el
        if (this.state.show) {
            el.addClass('active')

            if (this.props.fixed) {
                const bodyRect = document.body.getBoundingClientRect()
                const elemRect = parent.el.getBoundingClientRect()
                const offsetTop = elemRect.top - bodyRect.top
                const offsetLeft = elemRect.left - bodyRect.left

                el.css('top', `${offsetTop - this.el.height - 5}px`)
                el.css('left', `${offsetLeft + ((parent.width / 2) - (this.el.width / 2))}px`)

                document.addEventListener('scroll', this.hide, true)
            } else {
                const width = this.el.width // Width of the tooltip
                const height = this.el.height // Height of the tooltip

                const parentHeight = parent.el.offsetHeight / 4
                const left = (parent.width / 2) - (width / 2) // Calculate left position by the tooltip width and parent width

                el.css('left', left + 'px')
                el.css('top', `${-((height) + (parentHeight))}px`)
            }

        }
        return el
    }

}

export {TooltipComponent}
